/**
 * Schäfer Beraterin — Ablauf-Engine (Phase 1, deterministisch).
 *
 * Arbeitsweise:
 *  1. Einstiegsfrage -> waehlt den Ablauf (flows in ShBeraterConfig)
 *  2. Jede Antwort sammelt Kollektions-Handles, Stichwoerter und die
 *     Preisspanne ein
 *  3. Ergebnis: Produkte aus /collections/{handle}/products.json werden
 *     geladen, dedupliziert, nach Preis gefiltert und bewertet:
 *       +2 je getroffener Kollektion, +2 je Stichwort in Titel/Tags,
 *       +1 wenn der Preis in der Spanne liegt
 *     Die besten 6 werden mit einer Begruendungszeile gezeigt.
 *
 * Phase 2 (Livegang): dieselben gesammelten Antworten gehen als Kontext an
 * ein Claude-Backend — Engine austauschbar, Markup bleibt.
 *
 * Absichtlich KEINE Abhaengigkeiten und keine Speicherung: die Beratung
 * ist fluechtig; wer neu startet, startet neu.
 */
(function () {
  var cfg = window.ShBeraterConfig;
  var root = document.querySelector('[data-sh-berater]');
  if (!cfg || !root) return;

  var body = root.querySelector('[data-sh-ber-body]');
  var progress = root.querySelector('[data-sh-ber-progress]');
  var backBtn = root.querySelector('[data-sh-ber-back]');
  var restartBtn = root.querySelector('[data-sh-ber-restart]');

  var state = null;

  // ---------- Fensterlogik ----------

  function open() {
    if (!root.hidden) return;
    root.hidden = false;
    document.body.style.overflow = 'hidden';
    reset();
    root.querySelector('.sh-ber__close').focus();
  }

  function close() {
    root.hidden = true;
    document.body.style.overflow = '';
  }

  function reset() {
    state = { flow: null, stepIndex: -1, picks: [] };
    renderEntry();
  }

  root.querySelectorAll('[data-sh-ber-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !root.hidden) close();
  });
  restartBtn.addEventListener('click', reset);
  backBtn.addEventListener('click', goBack);

  // Oeffner: #beraterin-Links, data-Attribute, Deep-Link, globale API
  document.addEventListener('click', function (e) {
    var t = e.target.closest('a[href$="#beraterin"], [data-sh-berater-open]');
    if (!t) return;
    e.preventDefault();
    open();
  });
  if (location.hash === '#beraterin') open();
  window.ShBerater = { open: open, close: close };

  // ---------- Rendering ----------

  function totalSteps() {
    // Einstieg + Schritte des gewaehlten Ablaufs + Ergebnis
    var flowLen = state.flow ? cfg.flows[state.flow].length : 1;
    return 1 + flowLen + 1;
  }

  function renderProgress(current) {
    var total = totalSteps();
    var html = '';
    for (var i = 0; i < total; i++) {
      var cls = i < current ? 'is-done' : i === current ? 'is-active' : '';
      html += '<i class="' + cls + '"></i>';
    }
    progress.innerHTML = html;
  }

  function stepShell() {
    var el = document.createElement('div');
    el.className = 'sh-ber__step';
    body.innerHTML = '';
    body.appendChild(el);
    body.scrollTop = 0;
    return el;
  }

  function optionCard(opt) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'sh-ber__opt';
    var icon = document.createElement('span');
    icon.className = 'sh-ber__opt-icon';
    icon.textContent = opt.icon || '✨';
    icon.setAttribute('aria-hidden', 'true');
    var label = document.createElement('span');
    label.className = 'sh-ber__opt-label';
    label.textContent = opt.label;
    b.appendChild(icon);
    b.appendChild(label);
    if (opt.sub) {
      var sub = document.createElement('span');
      sub.className = 'sh-ber__opt-sub';
      sub.textContent = opt.sub;
      b.appendChild(sub);
    }
    return b;
  }

  function renderQuestion(questionText, options, onPick) {
    var el = stepShell();
    var h = document.createElement('h3');
    h.className = 'sh-ber__question';
    h.textContent = questionText;
    var grid = document.createElement('div');
    grid.className = 'sh-ber__opts' + (options.length > 4 ? ' sh-ber__opts--many' : '');
    options.forEach(function (opt) {
      var card = optionCard(opt);
      card.addEventListener('click', function () { onPick(opt); });
      grid.appendChild(card);
    });
    el.appendChild(h);
    el.appendChild(grid);
  }

  function renderEntry() {
    backBtn.hidden = true;
    restartBtn.hidden = true;
    renderProgress(0);
    renderQuestion(cfg.entry.question, cfg.entry.options, function (opt) {
      state.flow = opt.flow;
      state.stepIndex = 0;
      renderStep();
    });
  }

  function renderStep() {
    var steps = cfg.flows[state.flow];
    if (state.stepIndex >= steps.length) return renderResults();

    backBtn.hidden = false;
    restartBtn.hidden = true;
    renderProgress(1 + state.stepIndex);

    var step = steps[state.stepIndex];
    var options = step.budget ? cfg.budgets : step.options;
    renderQuestion(step.question, options, function (opt) {
      state.picks[state.stepIndex] = opt;
      state.stepIndex += 1;
      renderStep();
    });
  }

  function goBack() {
    if (state.stepIndex <= 0) return renderEntry();
    state.stepIndex -= 1;
    state.picks.length = state.stepIndex;
    renderStep();
  }

  // ---------- Auswahl-Engine ----------

  function gathered() {
    var collections = [];
    var keywords = [];
    var priceMin = 0;
    var priceMax = Infinity;
    state.picks.forEach(function (p) {
      if (!p) return;
      (p.collections || []).forEach(function (c) {
        if (collections.indexOf(c) === -1) collections.push(c);
      });
      (p.keywords || []).forEach(function (k) {
        if (keywords.indexOf(k) === -1) keywords.push(k);
      });
      if (p.min) priceMin = p.min;
      if (p.max) priceMax = p.max;
    });
    return { collections: collections, keywords: keywords, priceMin: priceMin, priceMax: priceMax };
  }

  function fetchCollection(handle) {
    return fetch(cfg.root + 'collections/' + handle + '/products.json?limit=50')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) {
        (d.products || []).forEach(function (p) { p._from = handle; });
        return d.products || [];
      })
      .catch(function () { return []; });
  }

  function euro(n) {
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(n);
  }

  function score(product, q) {
    var s = 0;
    var why = [];
    var hay = (product.title + ' ' + (product.tags || []).join(' ')).toLowerCase();

    s += 2; // aus einer getroffenen Kollektion geladen
    q.keywords.forEach(function (k) {
      if (hay.indexOf(k) > -1) { s += 2; }
    });

    var price = parseFloat(product.variants && product.variants[0] ? product.variants[0].price : '0');
    product._price = price;
    if (q.priceMax !== Infinity || q.priceMin > 0) {
      // harte Grenze mit 15 % Toleranz nach oben — knapp drueber ist ok
      if (price < q.priceMin || price > q.priceMax * 1.15) return null;
      s += 1;
      why.push(cfg.strings.whyBudget);
    }
    if (why.length === 0) why.push(cfg.strings.whyMatch);

    product._score = s;
    product._why = why[0];
    return product;
  }

  function renderResults() {
    backBtn.hidden = false;
    restartBtn.hidden = false;
    renderProgress(totalSteps() - 1);

    var el = stepShell();
    el.innerHTML = '<div class="sh-ber__loading"><span class="sh-ber__spinner" aria-hidden="true"></span>' +
      '<span>' + cfg.strings.loading + '</span></div>';

    var q = gathered();
    var handles = q.collections.length ? q.collections : ['frontpage'];

    Promise.all(handles.map(fetchCollection)).then(function (lists) {
      var seen = {};
      var candidates = [];
      lists.forEach(function (list) {
        list.forEach(function (p) {
          if (seen[p.id]) { seen[p.id]._score += 2; return; } // in mehreren Kollektionen = besser
          var scored = score(p, q);
          if (scored) { seen[p.id] = scored; candidates.push(scored); }
        });
      });
      candidates.sort(function (a, b) { return b._score - a._score || a._price - b._price; });
      renderResultCards(candidates.slice(0, 6), q, handles[0]);
    });
  }

  function renderResultCards(items, q, primaryHandle) {
    var el = stepShell();

    if (!items.length) {
      el.innerHTML =
        '<div class="sh-ber__empty">' +
        '<div class="sh-ber__empty-icon" aria-hidden="true">🌱</div>' +
        '<h3></h3><p></p></div>';
      el.querySelector('h3').textContent = cfg.strings.emptyTitle;
      el.querySelector('p').textContent = cfg.strings.emptyText;
      var link = document.createElement('a');
      link.className = 'sh-ber__viewall';
      link.href = cfg.root + 'collections/' + primaryHandle;
      link.textContent = cfg.strings.viewAll;
      el.querySelector('.sh-ber__empty').appendChild(link);
      return;
    }

    var head = document.createElement('div');
    head.className = 'sh-ber__results-head';
    var h = document.createElement('h3');
    h.textContent = cfg.strings.resultsTitle;
    var sub = document.createElement('p');
    sub.textContent = cfg.strings.resultsSub;
    head.appendChild(h);
    head.appendChild(sub);
    el.appendChild(head);

    var grid = document.createElement('div');
    grid.className = 'sh-ber__grid';
    items.forEach(function (p) {
      var a = document.createElement('a');
      a.className = 'sh-ber__card';
      a.href = cfg.root + 'products/' + p.handle;

      var imgWrap = document.createElement('div');
      imgWrap.className = 'sh-ber__card-img';
      if (p.images && p.images[0]) {
        var img = document.createElement('img');
        img.src = p.images[0].src;
        img.alt = '';
        img.loading = 'lazy';
        imgWrap.appendChild(img);
      }

      var cardBody = document.createElement('div');
      cardBody.className = 'sh-ber__card-body';
      var title = document.createElement('span');
      title.className = 'sh-ber__card-title';
      title.textContent = p.title;
      var price = document.createElement('span');
      price.className = 'sh-ber__card-price';
      price.textContent = euro(p._price);
      var tax = document.createElement('small');
      tax.textContent = cfg.taxNote;
      price.appendChild(tax);
      var why = document.createElement('span');
      why.className = 'sh-ber__why';
      why.innerHTML = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" ' +
        'stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<path d="M20 6 9 17l-5-5"/></svg>';
      var whyText = document.createElement('span');
      whyText.textContent = p._why;
      why.appendChild(whyText);

      cardBody.appendChild(title);
      cardBody.appendChild(price);
      cardBody.appendChild(why);
      a.appendChild(imgWrap);
      a.appendChild(cardBody);
      grid.appendChild(a);
    });
    el.appendChild(grid);

    var link = document.createElement('a');
    link.className = 'sh-ber__viewall';
    link.href = cfg.root + 'collections/' + primaryHandle;
    link.textContent = cfg.strings.viewAll;
    el.appendChild(link);
  }
})();
